import { getAuthToken } from './projectDataService';
import { handleUnauthorized } from '../api-utilities/api-calls';
import { getStringId } from '../api-utilities/formatting';
//This file contains calls to the Lowry backend, which gets results from the ChartAPI


const apibase = process.env.REACT_APP_CLIENT_API;

export async function getFanCurveChart(projectId: number, unitId: number, selectedFan: string) {
    const token = await getAuthToken();
    
    let projIdStr = getStringId('project', projectId);
    let unitIdStr = getStringId('unit', unitId);
    
    const result = await fetch(apibase + `/dataapi/getFanCurveChart/${projIdStr}/${unitIdStr}/${selectedFan}`, {
      method: 'get',
      headers: { Authorization: `Bearer ${token}` }
    });
    if(result.status === 400){
        return null;
    }
    if (result.status === 200) {
        console.log(result);
      const data = await result.blob();
      console.log(data);
      return data;
    }
    handleUnauthorized(result.status, 'getFanCurveChart');
}

export async function getFanSoundData(projectId: number, unitId: number, selectedFan: string) {
  const token = await getAuthToken();

  let projIdStr = getStringId('project', projectId);
  let unitIdStr = getStringId('unit', unitId);

  const result = await fetch(apibase + `/dataapi/getFanSoundData/${projIdStr}/${unitIdStr}/${selectedFan}`, {
    method: 'get',
    headers: { Authorization: `Bearer ${token}` }
  });
  
  //result.json is our expected json object.
  //result.text is how error messages come in.
  handleUnauthorized(result.status, 'getFanSoundData');
  const response = {
    success: result.status === 200 ? true : false,
    data: result.status === 200 ? await result.json() : await result.text()
  };
  return response;
}